import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRightFromBracket, faChevronRight, faCrown, faArrowLeftLong, faListDots } from '@fortawesome/free-solid-svg-icons';
// import CNLogo from '../../CNLogo';
import { navigation } from '../../../config/navigation'
// import { setDarkTheme } from '../../../redux/actions/appTheme';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../redux/actions/authentication'
import { getAllSkills } from '../../../redux/actions/skills';
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';

const SlideOverContent = ({ setOpen, isUserLoggedIn }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    // const store = useSelector(store => store);
    // const isDarkThemeEnabled = useSelector(store => store?.root?.darkTheme);

    // const handleThemeChangeClick = (e) => {
    //     dispatch(setDarkTheme(!isDarkThemeEnabled));
    //     console.log(store)
    // }
    const [allCourses, setAllCourses] = useState([]);
    const [allCategoriesClicked, setAllCategoriesClicked] = useState(false);
    const [showAllCourses, setShowAllCourses] = useState(false);
    const [selectedcourse_slug, setSelectedcourse_slug] = useState(null);
    const [selectedCourseTitle, setSelectedCourseTitle] = useState("");
    const [showCourseSkills, setShowCourseSkills] = useState(false);
    const [currentCourseSkills, setCurrentCourseSkills] = useState(null);
    const email = useSelector(store => store?.profileDetails?.email)
    const all_courses = useSelector(store => store?.courses?.allCourses)

    function logoutHandler() {
        setOpen(false)
        dispatch(logout())
        navigate("/")
    }

    useEffect(() => {
        setAllCourses(all_courses);
    }, [showAllCourses])

    useEffect(() => {
        if (selectedcourse_slug) {
            dispatch(getAllSkills(selectedcourse_slug, skillsRes => {
                setCurrentCourseSkills(skillsRes);
            }))
        }
    }, [showCourseSkills, selectedcourse_slug])


    const handleGoBack = (e) => {
        setAllCategoriesClicked(false);
        setShowAllCourses(false);
        setShowCourseSkills(false);
        setSelectedCourseTitle("");
        setCurrentCourseSkills([]);
        setSelectedcourse_slug(null);
    }

    const handlePremiumClick = (e) => {
        setOpen(false);
        navigate('/pricing')
    }

    const handleCourseClick = (e) => {
        Mixpanel.track(Constants.Mixpanel.MB_SIDEBAR_COURSE_CLICK, {
            distinct_id: email
        })
    }

    const handleSkillClick = (e) => {
        Mixpanel.track(Constants.Mixpanel.MB_SIDEBAR_SKILL_CLICK, {
            distinct_id: email
        })
    }

    return (
        <div className='flex overflow-y-auto flex-col w-full h-full'>
            <div className='flex flex-col'>
                {!allCategoriesClicked &&
                    <button onClick={handlePremiumClick} className="text-sm mt-3 mb-10 w-36 font-semibold bg-yellow-400 px-2 py-1 rounded w-full hover:bg-orange-400">
                        <span>
                            Get Premium
                            <FontAwesomeIcon className='ml-2' icon={faCrown} />
                        </span>
                    </button>}
                {
                    allCategoriesClicked &&
                    <div onClick={handleGoBack} className="flex self-start text-black cursor-pointer w-36">
                        <button className="text-sm font-semibold bg-white px-4 py-1 rounded w-full ">
                            <span>
                                <FontAwesomeIcon className='mr-2' icon={faArrowLeftLong} />
                                Back
                            </span>
                        </button>
                    </div>
                }
                <div className='mt-2 flex flex-col gap-3'>
                    {!allCategoriesClicked &&
                        <div onClick={(e) => {
                            setAllCategoriesClicked(true)
                            setShowAllCourses(true);
                        }} className='flex align-center'>
                            <FontAwesomeIcon className="p-1 text-gray-700 w-10" icon={faListDots} size="lg" />
                            <span className="text-md mt-1 lg:text-2xl font-medium">All Categories</span>
                            <FontAwesomeIcon className="p-2 text-gray-700 w-10 lg:w-20" icon={faChevronRight} size="sm" />
                        </div>
                    }

                    {!allCategoriesClicked && navigation.map((item, idx) => (
                        <div className='flex' key={idx}>
                            {item.location.includes("SlideOver") ?
                                <>
                                    {item.route ?
                                        <Link
                                            key={item.name}
                                            to={item.route}
                                            className="flex text-black"
                                            onClick={(e) => setOpen(false)}
                                        >
                                            <FontAwesomeIcon className="p-1 text-gray-700 w-10" icon={item.icon} size="lg" />
                                            <span className="text-md mt-1 lg:text-2xl font-medium">
                                                {item.name}
                                            </span>
                                        </Link> :
                                        <div className="flex align-center text-black rounded-md cursor-pointer">
                                            {/* <FontAwesomeIcon className="p-1 text-gray-700 w-10 lg:w-20" icon={item.icon} size="lg" /> */}
                                            <span className="text-md mt-1 lg:text-2xl font-medium">{item.name}</span>
                                        </div>}
                                </> : null}
                        </div>
                    ))}

                    {/* Logout Button */}
                    {/* {
                        !allCategoriesClicked && isUserLoggedIn &&
                        <div className="flex w-full text-black cursor-pointer mt-10 w-36">
                            <button className="text-left text-md font-semibold w-full " onClick={logoutHandler}>
                                <span>
                                    <FontAwesomeIcon className='rotate-180 mr-1' icon={faRightFromBracket} />
                                    Logout
                                </span>
                            </button>
                        </div>
                    } */}

                    {
                        showAllCourses && (
                            <div className='flex flex-col w-full gap-4 mt-3'>
                                {allCourses.map((course, idx) => (
                                    <div key={idx} onClick={(e) => {
                                        setSelectedcourse_slug(allCourses?.[idx]["course_slug"])
                                        setSelectedCourseTitle(allCourses?.[idx]?.["course-name"]?.replace("Course", ""))
                                        setShowAllCourses(false);
                                        setShowCourseSkills(true);
                                        handleCourseClick(e)
                                    }
                                    } className='inline-flex gap-2'>
                                        <img src={course?.course_icon?.url} alt="Course Icon" className='self-center w-4 h-4' />
                                        <span className="text-md mt-1 font-semibold lg:text-2xl font-medium">{course["course-name"].replace("Course", "")}</span>
                                        <FontAwesomeIcon className="p-2 text-gray-700 w-10 lg:w-20" icon={faChevronRight} size="sm" />
                                    </div>
                                ))
                                }
                            </div>
                        )}


                    {
                        showCourseSkills && (

                            <div className='flex flex-col w-full gap-2 overflow-y-auto'>
                                <span className='font-bold text-lg text-black'>{selectedCourseTitle}</span>
                                {
                                    currentCourseSkills?.map((skill, idx) => (
                                        <Link onClick={(e) => {
                                            setOpen(false)
                                            handleSkillClick(e)
                                        }}
                                            key={idx} className="flex justify-start" to={`${selectedcourse_slug}/${skill?.skill_slug}`}>
                                            <span className="text-sm mt-1 font-semibold lg:text-2xl font-medium">{skill["skill-name"]}</span>
                                            <FontAwesomeIcon className="p-2 text-gray-700 w-10" icon={faChevronRight} size="sm" />
                                        </Link>
                                    ))
                                }
                            </div>

                        )
                    }
                </div>
            </div>
            {/* <button type="button"
                onClick={handleThemeChangeClick}
                className="ml-10 mt-10 w-40 text-xl dark:bg-gray-50 dark:text-gray-900 bg-white border rounded-full px-2 py-1 hover:shadow-lg">
                {isDarkThemeEnabled ? '💡Light' : '🌙Dark'}
            </button> */}

            {/* <CNLogo className="self-end" textColor={"black"} /> */}
        </div >
    )
}

export default SlideOverContent